"use strict";

const colorConverter = {
	changeColorHex: function (color, s, l) {
		let output, rgb, hsl;

		if (color.includes("rgb")) {
			rgb = color
				.split("(")[1]
				.split(")")[0]
				.split(", ")
				.map((n) => parseInt(n));
			hsl = this.rgbToHsl(rgb);
		}
		if (color.includes("hsl")) {
			hsl = color
				.split("(")[1]
				.split(")")[0]
				.split(", ")
				.map((c, i) => (i === 0 ? c / 360 : c.slice(0, 1) / 100));
		}
		if (color.includes("#")) {
			rgb = this.hexToRgb(color);
			hsl = this.rgbToHsl(rgb);
		}

		hsl[1] = s / 100;
		hsl[2] = l / 100;
		const newRgb = this.hslToRgb(hsl);
		output = this.rgbToHex(newRgb);

		return output;
	},

	changeColorHsl: function (color, s, l) {
		let rgb, hsl;

		if (color.includes("rgb")) {
			rgb = color
				.split("(")[1]
				.split(")")[0]
				.split(", ")
				.map((n) => parseInt(n));
			hsl = this.rgbToHsl(rgb);
		}
		if (color.includes("hsl")) {
			hsl = color
				.split("(")[1]
				.split(")")[0]
				.split(", ")
				.map((c, i) => (i === 0 ? c / 360 : c.slice(0, 1) / 100));
		}
		if (color.includes("#")) {
			rgb = this.hexToRgb(color);
			hsl = this.rgbToHsl(rgb);
		}

		hsl[1] = s / 100;
		hsl[2] = l / 100;

		return `hsl(${Math.round(hsl[0] * 360)}, ${hsl[1] * 100}%, ${hsl[2] * 100}%)`;
	},

	hexToHsl: function (color) {
		const rgb = this.hexToRgb(color);
		const hsl = this.rgbToHsl(rgb);

		return hsl;
	},

	hexToRgb: function (color) {
		const noHash = color.slice(1);

		const r = parseInt(noHash.slice(0, 2), 16);
		const g = parseInt(noHash.slice(2, 4), 16);
		const b = parseInt(noHash.slice(4), 16);

		return [r, g, b];
	},

	rgbToHex: function (arr) {
		const [r, g, b] = [...arr];

		const rHex = r.toString(16);
		const gHex = g.toString(16);
		const bHex = b.toString(16);

		return "#" + rHex + gHex + bHex;
	},

	rgbToHsl: function (arr) {
		const [r, g, b] = arr.map((v) => (v /= 255));

		const minVal = Math.min(r, g, b);
		const maxVal = Math.max(r, g, b);
		const l = (minVal + maxVal) / 2;

		let h, s;

		if (minVal === maxVal) {
			h = s = 0;
		} else {
			const d = maxVal - minVal;

			s = l > 0.5 ? d / (2 - maxVal - minVal) : d / (maxVal - minVal);

			switch (maxVal) {
				case r:
					h = (g - b) / d + (g < b ? 6 : 0);
					break;
				case g:
					h = (b - r) / d + 2;
					break;
				case b:
					h = (r - g) / d + 4;
					break;
			}
			h /= 6;
		}

		return [h, s, l];
	},

	hslToRgb: function (arr) {
		const [h, s, l] = [...arr];
		let r, g, b, r_, g_, b_;

		const c = (1 - Math.abs(2 * l - 1)) * s;
		const h_ = (h * 360) / 60;
		const x = c * (1 - Math.abs((h_ % 2) - 1));

		if (0 <= h_ && h_ <= 1) [r_, g_, b_] = [...[c, x, 0]];
		if (1 <= h_ && h_ <= 2) [r_, g_, b_] = [...[x, c, 0]];
		if (2 <= h_ && h_ <= 3) [r_, g_, b_] = [...[0, c, x]];
		if (3 <= h_ && h_ <= 4) [r_, g_, b_] = [...[0, x, c]];
		if (4 <= h_ && h_ <= 5) [r_, g_, b_] = [...[x, 0, c]];
		if (5 <= h_ && h_ <= 6) [r_, g_, b_] = [...[c, 0, x]];

		const m = l - c / 2;

		r = Math.round((r_ + m) * 255);
		g = Math.round((g_ + m) * 255);
		b = Math.round((b_ + m) * 255);

		return [r, g, b];
	},

	hslToHex: function (arr) {
		const rgb = this.hslToRgb(arr);
		const hex = this.rgbToHex(rgb);

		return hex;
	},
};

export default colorConverter;
